import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import '../styles/noisefast.css';

const NoiseFastSuccessPage = () => {
  return (
    <div className="noisefast-page nf-success-page">
      {/* Subtle Header */}
      <header className="nf-header">
        <Link to="/" className="nf-logo" data-testid="nf-success-logo">
          GoCalFit
        </Link>
      </header>

      <section className="nf-success-content">
        <CheckCircle size={80} className="nf-success-icon" />
        <h1>You're in.</h1>
        <p className="nf-success-subhead">Check your email for Day 0.</p>
        
        <div className="nf-success-body">
          <p>Your 3-day Noise Fast starts now.</p>
          <p>Pick your one thing. Cut the input. And finally move.</p>
        </div>
        
        <div className="nf-success-reminder">
          <h3>Remember the deal:</h3>
          <ul>
            <li>No social media</li>
            <li>No podcasts</li>
            <li>No background noise</li>
            <li>No loopholes</li>
          </ul>
          <p className="nf-bold">If you follow it, it works.</p>
        </div>
      </section>

      <footer className="nf-footer">
        <Link to="/" className="nf-footer-logo">GoCalFit</Link>
        <p className="nf-footer-tagline">Serious movement. Serious play.</p>
      </footer>
    </div>
  );
};

export default NoiseFastSuccessPage;
